import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Button,
  Card,
  Col,
  Fade,
  FormControl,
  Image,
  InputGroup,
  Jumbotron,
  Nav,
  Row,
  Tab,
} from "react-bootstrap";
import {
  FaGlobeAsia,
  FaListAlt,
  FaMailBulk,
  FaRegNewspaper,
  FaSwatchbook,
  FaUserFriends,
} from "react-icons/fa";
import { Fade as ReactRevealFade } from "react-reveal";
import { Link } from "react-router-dom";
import LastPosts from "../Components/Blog/LastPosts";
import componentContext from "../Context";
import pajoohApp from "../Images/pajoohyar-app.png";
import estenad from "../Images/svg/document.svg";
import majmuesazi from "../Images/svg/folder.svg";
import hamzaman from "../Images/svg/sync.svg";
import sazmandehi from "../Images/svg/tags.svg";
import { t } from "../lib/utils";
import Estenad from "../Lottie/estenaddehi";
import Hamzaman from "../Lottie/hamzamansazi";
import Majmue from "../Lottie/majmuesazi";
import Sazman from "../Lottie/sazmandehi";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { BsArrowLeft } from "react-icons/bs";
import Chrome from "../Images/chrome.png";
import FireFox from "../Images/firefox.png";
import edge from "../Images/edge.png";
import "./Home.css";

const AnimatedCounter = ({ target, duration = 2000, children }) => {
  const [count, setCount] = useState(0);
  const ref = useRef();
  const observerRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          startCounting();
          if (observerRef.current) {
            observerRef.current.disconnect();
          }
        }
      },
      { threshold: 0.5 },
    );

    observerRef.current = observer;
    observer.observe(ref.current);

    return () => observer.disconnect();
    // eslint-disable-next-line
  }, []);

  const startCounting = () => {
    const startTime = Date.now();
    const updateCount = () => {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const currentCount = Math.floor(progress * target);

      setCount(currentCount);

      if (progress < 1) {
        requestAnimationFrame(updateCount);
      } else {
        setCount(target);
      }
    };

    requestAnimationFrame(updateCount);
  };

  return (
    <div ref={ref}>
      <h1>{count.toLocaleString()}</h1>
      {children}
    </div>
  );
};

const Home = () => {
  const context = useContext(componentContext);
  const [newsletter, setNewsletter] = useState("");
  const [showScrollButton, setShowScrollButton] = useState(false);

  const statisticsRef = useRef();

  const checkScrollTop = () => {
    setShowScrollButton(window.pageYOffset > 500);
  };

  const scrollTo = position => {
    window.scrollTo({
      top: position,
      behavior: "smooth",
    });
  };

  const scrollToTop = () => scrollTo(0);
  const scrollToBottom = () => scrollTo(document.documentElement.scrollHeight);

  useEffect(() => {
    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, []);

  const subscribe = () => {
    context.ApiDriver.subscribeNewsLetter(
      { email: newsletter },
      success => {
        context.notification("عضویت موفق‌آمیز بود", "success");
      },
      error => {
        for (let err in error.response.data.errors) {
          context.notification(error.response.data.errors[err], "error");
        }
      },
    );
  };

  return (
    <div className="home-page">
      <div>
        <div id="header" className="header row mx-0">
          <div className="d-flex header-links align-items-center justify-content-center w-100">
            <div className="text-white d-flex align-items-center justify-content-center flex-column text-center mx-2">
              <h1 className="mb-4">{t("websiteName")}</h1>
              <h4>{t("websiteDesc")}</h4>
              <div className="mb-4">
                <Button
                  bsPrefix="custom-button"
                  href="/product"
                  target="_blank">
                  {t("download")}
                </Button>
              </div>
              <h6>
                <span>برای تولید سریع کتابنامه از</span>
                <a
                  href="https://www.pajoohyar.ir/cite"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-weight-bold"
                  style={{ color: "orange" }}>
                  <span className="font-weight-bold">
                    {" "}
                    استناددهی آنلاین&nbsp;
                  </span>
                </a>
                <span>استفاده کنید.</span>
              </h6>
              <h6 style={{ marginTop: 8 }}>
                <span>با </span>
                <a
                  href="https://pajoohyar.ir/library/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-weight-bold"
                  style={{ color: "orange" }}>
                  پژوهیار آنلاین
                </a>
                <span> پژوهش را ساده‌تر مدیریت کنید.</span>
              </h6>
            </div>
          </div>
        </div>
      </div>

      {/* About Section */}
      <ReactRevealFade duration={1800}>
        <div className="row about-section mx-0">
          <Col md={6} sm={12} className="about-us-parent">
            <div className="about-us1">
              <h3>{t("about")}</h3>
              <p>{t("aboutDesc")}</p>
            </div>
          </Col>
          <Col
            md={6}
            sm={12}
            className="d-flex align-items-center justify-content-center">
            <Image className="about-us-img" src={pajoohApp} alt="تصویر برنامه پژوهیار" loading="lazy" fluid />
          </Col>
        </div>
      </ReactRevealFade>

      {/* Features Tabs Section */}
      <ReactRevealFade duration={1800}>
        <Row className="tabs-section mx-0 float-right text-right w-100">
          <Tab.Container id="left-tabs-example" defaultActiveKey="first">
            <Row className="mx-0 text-right w-100">
              <Col sm={12} md={3} className="align-items-center homePage-tabs">
                <Nav
                  variant="tabs"
                  className="nav-link-container flex-column justify-content-center"
                  transition={Fade}
                  style={{ border: "none" }}>
                  <Nav.Item className="Features-Tabs-navItem">
                    <Nav.Link
                      className="movies d-flex Features-Tabs-nav-link"
                      eventKey="first">
                      <div>
                        <Image src={majmuesazi} alt="آیکن مجموعه‌سازی" loading="lazy" style={{ height: 30 }} />
                      </div>
                      <div className="text-right Features-Tabs-nav-link-title">
                        مجموعه‌سازی
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="Features-Tabs-navItem">
                    <Nav.Link
                      className="movies d-flex Features-Tabs-nav-link"
                      eventKey="second">
                      <div>
                        <Image src={sazmandehi} alt="آیکن سازماندهی" loading="lazy" style={{ height: 30 }} />
                      </div>
                      <div className="text-right Features-Tabs-nav-link-title">
                        {" "}
                        سازماندهی
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="Features-Tabs-navItem">
                    <Nav.Link
                      className="movies d-flex Features-Tabs-nav-link"
                      eventKey="third">
                      <div>
                        <Image src={estenad} alt="آیکن استناددهی" loading="lazy" style={{ height: 30 }} />
                      </div>
                      <div className="text-right Features-Tabs-nav-link-title">
                        استناددهی
                      </div>
                    </Nav.Link>
                  </Nav.Item>
                  <Nav.Item className="Features-Tabs-navItem">
                    <Nav.Link
                      className="movies d-flex Features-Tabs-nav-link"
                      eventKey="fourth">
                      <div>
                        <Image src={hamzaman} alt="آیکن همزمان‌سازی" loading="lazy" style={{ height: 30 }} />
                      </div>
                      <div className="text-right Features-Tabs-nav-link-title">
                        همزمان‌سازی
                      </div>{" "}
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </Col>
              <Col md={9} sm={12}>
                <Tab.Content className="tab-pane1">
                  <Tab.Pane
                    eventKey="first"
                    className="pane-contents"
                    transition={Fade}>
                    <ReactRevealFade>
                      <Row className="m-0">
                        <Col md={12} className="pane-content">
                          <p>
                            اطلاعات کتاب‌شناختیِ انواع آیتم پژوهشی از قبیل کتاب،
                            پایان‌نامه و مقاله را در پوشه‌های اصلی و فرعی مجزا
                            قرار دهید و از این طریق با ایجاد مجموعه‌های موضوعی
                            به منابع خود نظم دهید.
                          </p>
                          <Majmue />
                        </Col>
                      </Row>
                    </ReactRevealFade>
                  </Tab.Pane>
                  <Tab.Pane
                    className="pane-contents"
                    eventKey="second"
                    transition={Fade}>
                    <ReactRevealFade>
                      <Row className="m-0">
                        <Col md={12} className="pane-content">
                          <p>
                            پس از ایجاد مجموعه‌ها، آیتم‌ها را ویرایش کنید و به
                            آن‌ها برچسب و یادداشت اختصاص دهید. این امکان به شما
                            کمک می‌کند تا در ادامه فرایند پژوهش، با سرعت و دقت
                            بالاتری اطلاعات موردنظر خود را بازیابی کنید.
                          </p>
                          <Sazman />
                        </Col>
                      </Row>
                    </ReactRevealFade>
                  </Tab.Pane>
                  <Tab.Pane className="pane-contents" eventKey="third">
                    <ReactRevealFade>
                      <Row className="m-0">
                        <Col md={12} className="pane-content">
                          <p>
                            پس از وارد کردن اطلاعات کتابشناختی منابع (به صورت
                            خودکار یا دستی)، شیوه استنادی مورد نظر خود را از
                            بانک شیوه‌های پژوهیار انتخاب کنید تا نرم‌افزار
                            کتابنامه و استناد درون‌متن را برای شما تولید کند.
                          </p>
                          <Estenad />
                        </Col>
                      </Row>
                    </ReactRevealFade>
                  </Tab.Pane>
                  <Tab.Pane className="pane-contents" eventKey="fourth">
                    <ReactRevealFade>
                      <Row className="m-0">
                        <Col md={12} className="pane-content">
                          <p>
                            با «ابر پژوهیار» در سیستم‌های مختلف به آخرین تغییرات
                            مجموعه‌های خود دسترسی پیدا کنید. با وارد شدن به حساب
                            کاربری خود، بدون نیاز به نصب نرم‌افزار، امکانات
                            پژوهیار به صورت برخط در اختیار شماست.
                          </p>
                          <Hamzaman />
                        </Col>
                      </Row>
                    </ReactRevealFade>
                  </Tab.Pane>
                </Tab.Content>
              </Col>
            </Row>
          </Tab.Container>
        </Row>
      </ReactRevealFade>

      {/* Browser Extension Section */}
      <ReactRevealFade duration={1800}>
        <div className="extension-section col-12 d-flex align-items-center justify-content-center w-100 p-0">
          <Jumbotron
            className="jumbotron-extension-section jumbotron-container w-100 text-center"
            fluid>
            <div className="shapes">
              <div className="shape shape-1"></div>
              <div className="shape shape-2"></div>
              <div className="shape shape-3"></div>
            </div>
            <h2 className="extension-section-title">
              افزونه مرورگرهای پژوهیار
            </h2>
            <p className="extension-section-description">
              به شما امکان می‌دهد صفحات وب، کتاب، مقالات تخصصی و منابع دیگر را
              از طریق وبگاه‌های اطلاعات کتاب‌شناختی و کتابخانه‌ای به کتابخانه
              پژوهیار اضافه کنید. این افزونه‌ها برای سه مرورگر پرکاربرد کروم،
              فایرفاکس و Edge فراهم شده است.
              <Link to={"/extensions"} target="_blank">
                <BsArrowLeft className="extension-link-arrow" />
              </Link>
            </p>
            <div className="extension-section-imgs">
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://microsoftedge.microsoft.com/addons/detail/%D8%B1%D8%A7%D8%A8%D8%B7-%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1/adcfppnkaeeengcanndhmflboobmhbfa">
                <img className="extension-section-img1" alt="Microsoft Edge" src={edge} loading="lazy" />
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://chromewebstore.google.com/detail/%D8%B1%D8%A7%D8%A8%D8%B7-%D9%BE%DA%98%D9%88%D9%87%DB%8C%D8%A7%D8%B1/epeaammaiaknlihkglijkmdfcpohgpid?hl=en-US&utm_source=ext_sidebar">
                <img alt="Google Chrome" src={Chrome} loading="lazy" />
              </a>
              <a
                rel="noopener noreferrer"
                target="_blank"
                href="https://addons.mozilla.org/en-US/firefox/addon/pajoohyar/?src=search">
                <img alt="Mozilla Firefox" src={FireFox} loading="lazy" />
              </a>
            </div>
          </Jumbotron>
        </div>
      </ReactRevealFade>

      {/* Blog Section */}
      <ReactRevealFade duration={1800}>
        <div className="blog-section">
          <Card
            body
            style={{
              fontSize: 34,
              textAlign: "center",
              color: "#ea5e24",
              fontWeight: "bold",
            }}>
            آخرین مقالات بلاگ
          </Card>
          <LastPosts />
        </div>
      </ReactRevealFade>

      {/* Statistics Section */}
      <ReactRevealFade duration={1800}>
        <Jumbotron className="statistics-section" fluid ref={statisticsRef}>
          <Row className="features1 mx-0">
            <Col md={3} sm={12} className="feature3 pt-3 pb-3">
              <FaUserFriends size={60} />
              <AnimatedCounter target={18000}>
                <p>بیش از ۱۸ هزار کاربر فعال پژوهیار در سراسر کشور</p>
                <h3>کاربران فعال</h3>
              </AnimatedCounter>
            </Col>
            <Col md={3} sm={12} className="feature4 pt-3 pb-3">
              <FaListAlt size={60} />
              <AnimatedCounter target={300}>
                <p>بیش از ۳۰۰ شیوه استاندارد اختصاصی برای استناد به منابع</p>
                <h3>
                  <Link to="/csl" style={{ color: "#f5f0f1" }}>
                    شیوه‌نامه
                  </Link>
                </h3>
              </AnimatedCounter>
            </Col>
            <Col md={3} sm={12} className="feature2 pt-3 pb-3">
              <FaGlobeAsia size={60} />
              <AnimatedCounter target={500}>
                <p>
                  بیش از ۵۰۰ پایگاه اطلاعاتی پشتیبانی‌شده (شامل ۸۰ پایگاه
                  اختصاصی) برای ذخیره داده‌های کتاب‌شناختی
                </p>
                <h3>
                  <Link to="/supported-sites" style={{ color: "#f5f0f1" }}>
                    مترجم
                  </Link>
                </h3>
              </AnimatedCounter>
            </Col>
            <Col md={3} sm={12} className="feature1 pt-3 pb-3">
              <FaSwatchbook size={60} />
              <AnimatedCounter target={150}>
                <p>بیش از ۱۵۰ مجموعه اطلاعات کتاب‌شناختی برای ذخیره در پژوهیار</p>
                <h3>
                  <Link to="/metadata" style={{ color: "#f5f0f1" }}>
                    فراداده
                  </Link>
                </h3>
              </AnimatedCounter>
            </Col>
          </Row>
        </Jumbotron>
      </ReactRevealFade>

      {/* Newsletter Section */}
      <ReactRevealFade duration={1800}>
        <div style={{ textAlign: "center", marginBottom: 50 }}>
          <Row className="m-0">
            <Col md={4}></Col>
            <Col md={4} className="news-letter">
              <FaRegNewspaper
                size={60}
                style={{ color: "#ea5e24", marginBottom: 10 }}
              />
              <h4>خبرنامه</h4>
              <p>
                با عضویت در خبرنامه پژوهیار از جدیدترین آموزش‌ها و اخبار ما مطلع
                شوید.
              </p>
              <InputGroup className="mb-3" style={{ direction: "ltr" }}>
                <InputGroup.Prepend>
                  <InputGroup.Text id="inputGroup-sizing-default">
                    <FaMailBulk size={10} style={{ color: "#ea5e24" }} />
                  </InputGroup.Text>
                </InputGroup.Prepend>
                <FormControl
                  aria-label="Default"
                  aria-describedby="inputGroup-sizing-default"
                  placeholder="لطفا ایمیل خود را وارد کنید"
                  onChange={e => {
                    setNewsletter(e.target.value);
                  }}
                />
              </InputGroup>
              <Button
                style={{ backgroundColor: "#ea5e24", borderColor: "#ea5e24" }}
                block
                onClick={subscribe}>
                عضویت
              </Button>
            </Col>
          </Row>
        </div>
      </ReactRevealFade>

      {/* Scroll Button */}
      <span
        className="scroll-button"
        onClick={showScrollButton ? scrollToTop : scrollToBottom}
        style={{
          position: "fixed",
          left: "20px",
          bottom: "20px",
          zIndex: 1000,
        }}>
        {showScrollButton ? <FaAngleUp /> : <FaAngleDown />}
      </span>
    </div>
  );
};

export default Home;
